import { Media } from '@gripp/shared-logic';
import { CardButton, SlideAction, useSlideLayoutSafe } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useLocation } from 'react-router-dom';

type Props = {
  media: Media;
  onPress?: (media: Media) => void;
};

export const ProductFileItem = ({ media, onPress }: Props) => {
  const slideLayout = useSlideLayoutSafe();
  const location = useLocation();

  return (
    <View style={styles.container}>
      <View style={styles.cardButton}>
        <CardButton
          text={media.name}
          color="white"
          leftIcon="Document B"
          rightIcon="Chevron Right"
          showAvatars={false}
          bordered={false}
          onPress={media.id ? async () => {
              const isFileUrl = /\/products\/[^/]+\/files\/[^/]+/.test(location.pathname);
              if (!isFileUrl) {
                await slideLayout?.onSlideChange(SlideAction.NEXT);
              }
              onPress?.(media);
            } : undefined}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  cardButton: {
    flex: 1,
  },
});
